import { resources } from "./resources";
import { Culture } from "../types/culture";
import sqlMessage from "./sqlMessage.json";
import { AplError } from "../types/aplError";

const translateColumns = <T>(columns: T[], culture: Culture): T[] => {
    const translations = resources[culture ?? "en-GB"].translation.main;
    return columns.map((column: any) => ({
        ...column,
        title: column.title === "" ? "" : translations[column.title as any] || `TRANSLATE.${column.title}`
    }));
};

const translateString = (key: string, culture: Culture): string => {
    const translations = resources[culture ?? "en-GB"].translation.main;
    return translations[key as any] ?? key;
};

const translateSqlMessage = (code: number, defaultText: string, culture: Culture) => {
    let msg = sqlMessage.find(x => x.messageCode === code && x.culture === culture);
    if (msg) return `${code} - ${msg.textMessage}`;

    let msgEn = sqlMessage.find(x => x.messageCode === code && x.culture === "en-GB");
    if (msgEn) return `${code} - ${msgEn.textMessage}`;

    return `${defaultText}`;
};

const getExceptionText = (aplError: AplError | null | undefined, culture: Culture): string => {
    if(aplError != null) {
        if(aplError.aplErrorCode != null) {
            return translateSqlMessage(aplError.aplErrorCode, aplError.detail, culture);
        }
        return aplError.detail;
    }
    return "";
}

let isUsDate = (culture: Culture) => culture === "en-US";

export { translateColumns, isUsDate, translateString, translateSqlMessage, getExceptionText };
